export enum EAccountType {
  TRIAL = "TRIAL",
  DEVELOPER = "DEVELOPER",
  TEAM = "TEAM",
  SEAT_BASED_TEAM = "SEAT_BASED_TEAM",
  ENTERPRISE = "ENTERPRISE",
  ANON = "ANON"
}
